<template>
    <div>
        <MulReportHeader :dataFrom="table.params" @search="searchData" :loading="loading" :toPdf="toPdf" :excelShow="false"></MulReportHeader>
        <Collapse v-model="panelName">
            <Panel v-for="(item, index) in table.data" :key="index" :name="`${item.platid}`">
                {{ item.platname }}
                <Table border :columns="table.columns" :data="item.data" style="margin-top: 12px" ref="tableRef" slot="content"></Table>
            </Panel>
        </Collapse>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
export default {
    name: 'HandicapRetentionData',
    components: { MulReportHeader },
    data() {
        return {
            panelName: [],
            timestamp: 0,
            loading: false,
            TransTopReqTimer: null,
            table: {
                params: {
                    platids: [],
                    app_ids: [],
                    dataTime: this.getCurrentZeroDay()
                },
                data: [],
                columns: [
                    {
                        key: 'app_name',
                        width: 90,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '盘口', '显示对应的盘口名称')
                    },
                    {
                        key: 'time',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '对比时间', '显示对比时间')
                    },
                    {
                        key: 'pay_user_num',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当天转入人数', '当天首充的玩家数量'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, Math.ceil(params.row.pay_user_num || 0))
                    },
                    {
                        key: 'new_user_pay_num',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当天新增转入人数', '显示当天新增的首充的玩家数量'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, Math.ceil(params.row.new_user_pay_num || 0))
                    },
                    {
                        key: 'add_ci_ri_pay_rate',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '新增次日复充率', '显示新增次日复充人数/当天新增转入人数'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, (params.row.add_ci_ri_pay_rate * 100 || 0).toFixed(2) + '%')
                    },
                    {
                        key: 'add_three_pay_rate',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '新增3日复充率', '显示新增3日复充人数/当天新增转入人数'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, (params.row.add_three_pay_rate * 100 || 0).toFixed(2) + '%')
                    },
                    {
                        key: 'add_seven_pay_rate',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '新增7日复充率', '显示新增7日复充人数/当天新增转入人数'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, (params.row.add_seven_pay_rate * 100 || 0).toFixed(2) + '%')
                    },
                    {
                        key: 'ci_ri_pay_rate',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入次日复充率', '显示次日复充人数/当天转入人数'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, (params.row.ci_ri_pay_rate * 100 || 0).toFixed(2) + '%')
                    },
                    {
                        key: 'three_pay_rate',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入3日复充率', '显示3日复充人数/当天转入人数'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, (params.row.three_pay_rate * 100 || 0).toFixed(2) + '%')
                    },
                    {
                        key: 'seven_pay_rate',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入7日复充率', '显示7日复充人数/当天转入人数'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, (params.row.seven_pay_rate * 100 || 0).toFixed(2) + '%')
                    },
                    {
                        key: 'ci_ri_login_rate',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入次日留存率', '当天首充玩家，在第2天登录的人数/当天转入人数'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, (params.row.ci_ri_login_rate * 100 || 0).toFixed(2) + '%')
                    },
                    {
                        key: 'three_login_rate',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入3日留存率', '当天首充玩家，在第3天登录的人数/当天转入人数'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, (params.row.three_login_rate * 100 || 0).toFixed(2) + '%')
                    },
                    {
                        key: 'seven_login_rate',
                        widht: 120,
                        resizable: true,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入7日留存率', '当天首充玩家，在第7天登录的人数/当天转入人数'),
                        render: (h, params) => h('span', { style: { color: this.getColor(params) } }, (params.row.seven_login_rate * 100 || 0).toFixed(2) + '%')
                    }
                    // {
                    //     key: 'online_pay_rate',
                    //     minwidht: 120,
                    //     align: 'center',
                    //     renderHeader: (h) => this.renderHeader(h, '线上转入成功率', ' 成功转入订单数/提交转入订单数'),
                    //     render: (h, params) => h('span', { style: { color: this.getColor(params) } }, (params.row.online_pay_rate * 100 || 0).toFixed(2) + '%'),
                    // },
                ]
            }
        }
    },
    methods: {
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        getColor(params) {
            if (params.row.type) return ''
            return params.row[params.column.key] < 0 ? 'red' : params.row[params.column.key] > 0 ? '#32CD32' : '#333'
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 6000)
        },
        getTransTopParams(func, _param) {
            return {
                mod: 'root',
                platid: _param.platid,
                app_id: _param.app_id,
                app_name: _param.app_name,
                platname: _param.platname,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param
                }
            }
        },

        async searchData(emitProps) {
            if (this.loading) return
            let from = this.table.params
            let allList = this.getAllHttpAppid(from)
            let httpList = []
            let loadingArr = [...allList]
            let timestamp = new Date().getTime()
            this.timestamp = timestamp
            let initStartTime = this.getSecond(from.dataTime)
            let timeMap = {
                tStime: initStartTime,
                tEtime: initStartTime + 24 * 60 * 60 - 1,
                fStime: initStartTime - 5 * 24 * 60 * 60,
                fEtime: initStartTime - 1
            }
            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let item = emitProps.app_list.find((el) => el.appid == app_id)
                let app_name = item.appName
                let platid = item.platform
                let platname = emitProps.plat_list.find((el) => el.id == platid).name
                //当天数据 GetNewPlatfromNewPayInfo新增转入复充  GetNewPlatformRepeatPayInfo转入复充 转入留存
                let param = this.getTransTopParams('GetNewPlatfromNewPayInfo', { platid, app_id, app_name, platname, stime: timeMap.tStime, etime: timeMap.tEtime, timestamp, mix_point: 0.01, general: -1, pack_no: -1 })
                let param1 = this.copyData(param)
                param1.param._func = 'GetNewPlatformRepeatPayInfo'
                let param2 = this.copyData(param)
                param2.param._func = 'GetNewPlatfromData'

                // let param3 = this.copyData(param));
                // param3.param._func = "GetNewPlatfromFistPayData";

                //对比数据
                let param4 = this.copyData(param)
                param4.param._param.stime = timeMap.fStime
                param4.param._param.etime = timeMap.fEtime

                let param5 = this.copyData(param4)
                param5.param._func = 'GetNewPlatformRepeatPayInfo'

                let param6 = this.copyData(param4)
                param6.param._func = 'GetNewPlatfromData'

                // let param7 = this.copyData(param4));
                // param7.param._func = "GetNewPlatfromFistPayData";

                httpList.push([param, param1, param2, param4, param5, param6])
            }
            this.openTimer()
            this.table.data = []
            this.table.data = []
            let dateMap = {}
            this.panelName = []
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, dateMap, loadingArr)
            }
        },

        async toHttp(httpList, dateMap, loadingArr) {
            if (httpList.length > 0) {
                this.openTimer()
                let paramList = httpList.shift()
                let param = paramList.shift()
                let app_name = param.app_name
                //对比1新增次日复充
                let data = await this.currentNewData(param)
                //对比1留存数据
                let param1 = paramList.shift()
                let data1 = await this.otherDayData(param1)
                //对比1盘口数据
                let result2 = await TransTopReq(paramList.shift())
                let from = result2._param.data[0]
                let data2 = [
                    {
                        online_pay_all_num: from.online_pay_all_num,
                        online_pay_success_num: from.online_pay_success_num,
                        new_user_pay_num: from.new_user_pay_num,
                        pay_user_num: from.pay_user_num,
                        time: moment(from.time).format('YYYY-MM-DD')
                    }
                ]
                //对比2新增留存数据
                let param3 = paramList.shift()
                let data3 = await this.currentNewData(param3, true)

                //对比2留存
                let param4 = paramList.shift()
                let data4 = await this.otherDayData(param4, true)
                //对比2盘口数据
                let result5 = await TransTopReq(paramList.shift())
                let data5 = result5._param.data.map((item) => {
                    return {
                        online_pay_all_num: item.online_pay_all_num,
                        online_pay_success_num: item.online_pay_success_num,
                        online_pay_rate: this.calcRate(item.online_pay_success_num, item.online_pay_all_num),
                        new_user_pay_num: item.new_user_pay_num,
                        pay_user_num: item.pay_user_num
                    }
                })
                //当天数据
                let tData = Object.assign({ app_name }, data[0], data1[0], data2[0])
                tData.online_pay_rate = this.calcRate(tData.online_pay_success_num, tData.online_pay_all_num)
                tData.type = 1
                //五日平均数据 差值
                let aData
                let len = data3.length
                for (let i = 0; i < len; i++) {
                    if (i == 0) {
                        aData = Object.assign({}, data3[i], data4[i], data5[i])
                    } else {
                        for (let key in aData) {
                            if (key != 'idate' && key != 'time') aData[key] += data3[i][key] || data4[i][key] || data5[i][key] || 0
                        }
                    }
                }
                aData.time = '最近5天日均'
                aData.type = 1
                // aData.add_ci_ri_pay_rate = aData.add_ci_ri_calc_num ? aData.add_ci_ri_pay_num / aData.add_ci_ri_calc_num : 0;
                // aData.add_three_pay_rate = aData.add_three_calc_num ? aData.add_three_pay_num / aData.add_three_calc_num : 0;
                // aData.add_seven_pay_rate = aData.add_seven_calc_num ? aData.add_seven_pay_num / aData.add_seven_calc_num : 0;
                // aData.ci_ri_pay_rate = aData.ci_ri_calc_num ? aData.ci_ri_pay_num / aData.ci_ri_calc_num : 0;
                // aData.three_pay_rate = aData.three_calc_num ? aData.three_pay_num / aData.three_calc_num : 0;
                // aData.seven_pay_rate = aData.seven_calc_num ? aData.seven_pay_num / aData.seven_calc_num : 0;
                // aData.three_login_rate = aData.three_calc_num ? aData.three_login_num / aData.three_calc_num : 0;
                // aData.ci_ri_login_rate = aData.ci_ri_calc_num ? aData.ci_ri_login_num / aData.ci_ri_calc_num : 0;
                // aData.seven_login_rate = aData.seven_calc_num ? aData.seven_login_num / aData.seven_calc_num : 0;
                // aData.online_pay_rate = aData.online_pay_all_num ? aData.online_pay_success_num / aData.online_pay_all_num : 0;
                aData.add_ci_ri_pay_rate = this.calcRate(aData.add_ci_ri_pay_rate, len)
                aData.add_three_pay_rate = this.calcRate(aData.add_three_pay_rate, len)
                aData.add_seven_pay_rate = this.calcRate(aData.add_seven_pay_rate, len)
                aData.ci_ri_pay_rate = this.calcRate(aData.ci_ri_pay_rate, len)
                aData.three_pay_rate = this.calcRate(aData.three_pay_rate, len)
                aData.seven_pay_rate = this.calcRate(aData.seven_pay_rate, len)
                aData.three_login_rate = this.calcRate(aData.three_login_rate, len)
                aData.ci_ri_login_rate = this.calcRate(aData.ci_ri_login_rate, len)
                aData.seven_login_rate = this.calcRate(aData.seven_login_rate, len)
                aData.online_pay_rate = this.calcRate(aData.online_pay_rate, len)
                aData.pay_user_num = this.calcRate(aData.pay_user_num, len)
                aData.new_user_pay_num = this.calcRate(aData.new_user_pay_num, len)

                //计算当天-日均
                let cData = {}
                cData.user_pay_num = tData.user_pay_num - aData.user_pay_num
                cData.new_user_pay_num = tData.new_user_pay_num - aData.new_user_pay_num
                cData.add_ci_ri_pay_rate = tData.add_ci_ri_pay_rate - aData.add_ci_ri_pay_rate
                cData.add_three_pay_rate = tData.add_three_pay_rate - aData.add_three_pay_rate
                cData.add_seven_pay_rate = tData.add_seven_pay_rate - aData.add_seven_pay_rate
                cData.ci_ri_pay_rate = tData.ci_ri_pay_rate - aData.ci_ri_pay_rate
                cData.three_pay_rate = tData.three_pay_rate - aData.three_pay_rate
                cData.seven_pay_rate = tData.seven_pay_rate - aData.seven_pay_rate
                cData.three_login_rate = tData.three_login_rate - aData.three_login_rate
                cData.ci_ri_login_rate = tData.ci_ri_login_rate - aData.ci_ri_login_rate
                cData.seven_login_rate = tData.seven_login_rate - aData.seven_login_rate
                cData.online_pay_rate = tData.online_pay_rate - aData.online_pay_rate
                cData.pay_user_num = tData.pay_user_num - Math.ceil(aData.pay_user_num)
                cData.new_user_pay_num = tData.new_user_pay_num - Math.ceil(aData.new_user_pay_num)
                cData.time = '当天 - 日均'
                cData.type = 0
                loadingArr.shift()
                let find = this.table.data.find((el) => el.platid == param.platid)
                if (find) {
                    find.data.push(...[tData, aData, cData])
                } else {
                    this.panelName.push(`${param.platid}`)
                    this.table.data.push({
                        platid: param.platid,
                        platname: param.platname,
                        data: [tData, aData, cData]
                    })
                }
                if (loadingArr.length == 0) {
                    this.closeTimer()
                    return
                }
                this.toHttp(httpList, dateMap, loadingArr)
            }
        },
        //当天新增复充数据处理
        async currentNewData(param, isRange = false) {
            let realHttp1 = { ...param }
            realHttp1.param._param.stime -= 24 * 60 * 60
            realHttp1.param._param.etime -= 24 * 60 * 60
            let result = await TransTopReq(realHttp1)
            let data = result._param.data.map((item) => {
                if (isRange) {
                    return {
                        add_ci_ri_pay_num: item.ci_ri_pay_num,
                        add_ci_ri_calc_num: item.new_user_pay_num,
                        add_ci_ri_pay_rate: item.ci_ri_pay_rate
                    }
                } else {
                    return { add_ci_ri_pay_rate: item.ci_ri_pay_rate }
                }
            })
            //对比1新增三日复充
            let realHttp2 = { ...realHttp1 }
            realHttp2.param._param.stime -= 24 * 60 * 60
            realHttp2.param._param.etime -= 24 * 60 * 60
            let result_three = await TransTopReq(realHttp2)
            result_three._param.data.forEach((item, index) => {
                if (isRange) {
                    Object.assign(data[index], {
                        add_three_pay_num: item.three_pay_num,
                        add_three_calc_num: item.new_user_pay_num,
                        add_three_pay_rate: item.three_pay_rate
                    })
                } else {
                    Object.assign(data[index], {
                        add_three_pay_rate: item.three_pay_rate
                    })
                }
            })
            //对比1新增七日复充
            let realHttp3 = { ...realHttp2 }
            realHttp3.param._param.stime -= 4 * 24 * 60 * 60
            realHttp3.param._param.etime -= 4 * 24 * 60 * 60
            let result_seven = await TransTopReq(realHttp3)
            result_seven._param.data.forEach((item, index) => {
                if (isRange) {
                    Object.assign(data[index], {
                        add_seven_pay_num: item.seven_pay_num,
                        add_seven_calc_num: item.new_user_pay_num,
                        add_seven_pay_rate: item.seven_pay_rate
                    })
                } else {
                    Object.assign(data[index], {
                        add_seven_pay_rate: item.seven_pay_rate
                    })
                }
            })
            return data
        },
        async otherDayData(param, isRange = false) {
            let realHttp1 = { ...param }
            realHttp1.param._param.stime -= 24 * 60 * 60
            realHttp1.param._param.etime -= 24 * 60 * 60
            let result = await TransTopReq(realHttp1)
            let { ci_ri_pay_rate, ci_ri_login_rate } = result._param.data[0]
            let data = result._param.data.map((item) => {
                if (isRange) {
                    return {
                        ci_ri_pay_num: item.ci_ri_pay_num,
                        ci_ri_calc_num: item.user_pay_num,
                        ci_ri_login_num: item.ci_ri_login_num,
                        ci_ri_pay_rate: item.ci_ri_pay_rate,
                        ci_ri_login_rate: item.ci_ri_login_rate
                    }
                } else {
                    return {
                        ci_ri_pay_rate: item.ci_ri_pay_rate,
                        ci_ri_login_rate: item.ci_ri_login_rate
                    }
                }
            })
            //对比1新增三日复充
            let realHttp2 = { ...realHttp1 }
            realHttp2.param._param.stime -= 24 * 60 * 60
            realHttp2.param._param.etime -= 24 * 60 * 60
            let result_three = await TransTopReq(realHttp2)
            result_three._param.data.forEach((item, index) => {
                if (isRange) {
                    Object.assign(data[index], {
                        three_pay_num: item.three_pay_num,
                        three_calc_num: item.user_pay_num,
                        three_login_num: item.three_login_num,
                        three_pay_rate: item.three_pay_rate,
                        three_login_rate: item.three_login_rate
                    })
                } else {
                    Object.assign(data[index], {
                        three_pay_rate: item.three_pay_rate,
                        three_login_rate: item.three_login_rate
                    })
                }
            })
            //对比1新增七日复充
            let realHttp3 = { ...realHttp2 }
            realHttp3.param._param.stime -= 4 * 24 * 60 * 60
            realHttp3.param._param.etime -= 4 * 24 * 60 * 60
            let result_seven = await TransTopReq(realHttp3)
            let { seven_pay_rate, seven_login_rate } = result_seven._param.data[0]
            result_seven._param.data.forEach((item, index) => {
                if (isRange) {
                    Object.assign(data[index], {
                        seven_pay_num: item.seven_pay_num,
                        seven_calc_num: item.user_pay_num,
                        seven_login_num: item.seven_login_num,
                        seven_pay_rate: item.seven_pay_rate,
                        seven_login_rate: item.seven_login_rate
                    })
                } else {
                    Object.assign(data[index], {
                        seven_pay_rate: item.seven_pay_rate,
                        seven_login_rate: item.seven_login_rate
                    })
                }
            })
            return data
        },
        //留存数据处理 data type = 新增add 留存2 首充first
        proData(data, type = '') {
            let str = type ? `${type}_` : ''
            let newData = data.map((item) => {
                let newItem = {}
                for (let key in item) {
                    newItem[str + key] = item[key]
                }
                return newItem
            })
            return newData || []
        },

        toPdf() {
            this.panelName = this.table.data.map((el) => `${el.platid}`)
            this.$nextTick(() => {
                this.eleToPdf()
            })
        },
        //分组变化清空盘口选择项
        updateSelect() {
            this.table.params.app_ids = []
        },

        rColItem(h, params, isMoney = false) {
            let field = params.column.key
            let isFour = params.row.idate == '环比'
            let value = params.row[field]
            let type = params.row.type
            if (isMoney && !isFour) {
                value = this.getCustomFixed(value / 10000)
            }
            let color = this.rCol(type, value)
            let str = !isFour ? value : (value * 100).toFixed(2) + '%'
            return h('span', { style: { color } }, str)
        },
        rCol(type, num) {
            if (type) {
                if (num > 0) return '#32CD32'
                if (num == 0) return '#333'
                return 'red'
            } else {
                return '#333'
            }
        }
    }
}
</script>

<style scoped lang="less"></style>
